import { use } from 'echarts/lib/echarts';
import { install } from './linesGL/install';
use(install);